export default __webpack_public_path__ + "img/service_DS2.bdb8be29a3f81902a1237d10bcf20344.jpg";